var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import GlobalVue from "../../globalVue";
import ShopAfterSalesService from '../../api/ShopAfterSalesService';
import ObjectHelper from '../../helper/objectHelper';
import Header from "./components/Header.vue";
import CheckDialog from './components/CheckDialog';
import CancelDialog from './components/CancelDialog.vue';
import { Loading } from 'element-ui';
import { EBillType } from "../../enum/EBillType";
import { toDetail } from '../../helper/util';
import ConfirmBack from "../purchaseback/component/ConfirmBack.vue";
import Add from './Add.vue';
var shopAfterSalesList = (function (_super) {
    __extends(shopAfterSalesList, _super);
    function shopAfterSalesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.apply_refund_money = 0;
        _this.tableHeight = 300;
        _this.selectRows = [];
        return _this;
    }
    shopAfterSalesList.prototype.created = function () {
        this.service = ShopAfterSalesService.getInstance();
    };
    shopAfterSalesList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 210;
        }, 300);
    };
    shopAfterSalesList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    shopAfterSalesList.prototype.checkSelectIds = function () {
        console.log(2222, this.selectRows);
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择单据！');
            return false;
        }
        else {
            return true;
        }
    };
    shopAfterSalesList.prototype.getSelectIds = function () {
        var type_ids = this.selectRows.map(function (item) { return item.refund_order_id; });
        return type_ids.join(',');
    };
    shopAfterSalesList.prototype.syncOrders = function (data) {
        var _this = this;
        console.log(22222, this.selectRows);
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error("请选择售后工单");
            return;
        }
        var orderIds = this.selectRows.map(function (item) {
            return item.refund_order_id;
        }).join(",");
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.syncOrders({
            order_ids: orderIds
        }).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 0) {
                _this.$message.success(res.data.msg || "同步分拣系统成功");
                _this.search(__assign({}, data));
                return;
            }
            else if (res.data.code == 76) {
                _this.$message.error(res.data.msg || res.data.message);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    shopAfterSalesList.prototype.delRefundOrder = function () {
        var _this = this;
        if (!this.checkSelectIds())
            return;
        this.$confirm('请确认是否确认要废弃？').then(function () {
            var refund_order_ids = _this.getSelectIds();
            console.log(1111, refund_order_ids);
            var instance = _this.$dialog(CancelDialog, {
                data: {
                    refund_order_ids: refund_order_ids,
                }
            }, {
                title: "处理售后工单",
                width: 526,
                height: 340
            }).instance;
            instance.$on("check:ok", function (res, params) {
                _this.getList();
            });
        }, function (err) { });
    };
    shopAfterSalesList.prototype.search = function (filter) {
        var pagination = this.$refs.pagination;
        if (pagination) {
            pagination.handleCurrentChange(1, 1);
        }
        var currentPager = pagination ? pagination.getPage() : { page: 1, start: 0, limit: 20 };
        if (filter) {
            this.filter = filter;
        }
        this.getList(currentPager);
    };
    shopAfterSalesList.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getList(__assign({}, pager, this.filter))
            .then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data || [];
            _this.total = res.data.total;
            _this.apply_refund_money = res.data.statistic.apply_refund_money || 0;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    shopAfterSalesList.prototype.toDeliver = function (delivery_order_id) {
        toDetail(EBillType.Deliver, delivery_order_id);
    };
    shopAfterSalesList.prototype.handle = function (row) {
        var _this = this;
        var instance = this.$dialog(CheckDialog, {
            data: {
                rowData: ObjectHelper.serialize(row)
            }
        }, {
            title: "处理售后工单",
            width: 526,
            height: 340
        }).instance;
        instance.$on("check:ok", function (res, params) {
            console.log(666, res, params);
            if (res.code === 9995) {
                var dialog = _this.$dialog(ConfirmBack, {
                    data: {
                        data: res.data,
                        msg: res.msg,
                        saleAfterParams: params,
                        type: 'saleAfter'
                    },
                }, {
                    title: "退货确认",
                    width: 950,
                    height: 600,
                    zIndex: 3000,
                });
                dialog.instance.$on("save:ok", function (row) {
                    _this.getList();
                });
                return;
            }
            _this.getList();
        });
    };
    shopAfterSalesList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    shopAfterSalesList.prototype.lookDetail = function (row) {
        toDetail(EBillType.ShopAfterSales, row.refund_order_id, this);
    };
    shopAfterSalesList.prototype.lookPurchaseOrderOrderDetail = function (row) {
        toDetail(EBillType.PurOrder, row.purchase_order_order_id, this);
    };
    shopAfterSalesList.prototype.editRefundOrder = function (row) {
        if (this.ediStatus) {
            this.$message.error('开启第三方系统对接后不支持编辑售后工单');
            return;
        }
        console.log('编辑', row);
        GlobalVue.$emit("addTab", {
            component: Add,
            title: '编辑售后工单',
            showExist: true,
            name: 'edit_refund_order_' + row.refund_order_id,
            cprops: {
                rowId: row.refund_order_id,
                opener: this,
                openerFilter: this.filter,
                Root_PageAuth: this.Root_PageAuth,
            }
        });
    };
    shopAfterSalesList = __decorate([
        Component({
            components: {
                'list-header': Header
            },
            computed: __assign({}, mapGetters({
                "ediStatus": "ediStatus"
            }))
        })
    ], shopAfterSalesList);
    return shopAfterSalesList;
}(Vue));
export default shopAfterSalesList;
